/* eslint-disable */
import { doc, writeBatch } from "firebase/firestore";

const normalize = (value) => String(value || "").trim().toLowerCase();

const toPositiveQuantity = (value, fallback = 1) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const extractOrderItems = (order) => {
  if (!order) return [];

  if (Array.isArray(order.products) && order.products.length > 0) {
    return order.products.map((item) => ({
      productId: item?.productId || item?.id || null,
      sku: item?.sku || null,
      name: item?.name || null,
      quantity: toPositiveQuantity(item?.quantity ?? item?.qty, 1),
    }));
  }

  return [
    {
      productId: order?.productId || null,
      sku: order?.sku || null,
      name: order?.nameproduct || null,
      quantity: toPositiveQuantity(order?.qty, 1),
    },
  ];
};

const resolveProductFromCatalog = (catalog, item) => {
  const productId = String(item?.productId || "");
  if (productId) {
    const byId = catalog.find((product) => String(product?.id) === productId);
    if (byId) return byId;
  }

  const sku = normalize(item?.sku);
  if (sku) {
    const bySku = catalog.find((product) => normalize(product?.sku) === sku);
    if (bySku) return bySku;
  }

  const name = normalize(item?.name);
  if (name) {
    const byName = catalog.find((product) => normalize(product?.name) === name);
    if (byName) return byName;
  }

  return null;
};

export const decreaseOrderProductsStock = async ({ db, order, productsCatalog = [] }) => {
  if (!db || !order) {
    return { applied: false, updatedCount: 0, updatedProducts: [] };
  }

  const items = extractOrderItems(order);

  if (!items.length) {
    return { applied: false, updatedCount: 0, updatedProducts: [] };
  }

  const qtyToDeductByProductId = new Map();

  items.forEach((item) => {
    const matchedProduct = resolveProductFromCatalog(productsCatalog, item);
    if (!matchedProduct?.id) {
      return;
    }

    const currentAmount = qtyToDeductByProductId.get(matchedProduct.id) || 0;
    qtyToDeductByProductId.set(
      matchedProduct.id,
      currentAmount + toPositiveQuantity(item.quantity, 1),
    );
  });

  if (!qtyToDeductByProductId.size) {
    return { applied: false, updatedCount: 0, updatedProducts: [] };
  }

  const catalogById = new Map(
    productsCatalog.map((product) => [String(product?.id), product]),
  );

  const batch = writeBatch(db);
  const updatedProducts = [];

  qtyToDeductByProductId.forEach((qtyToDeduct, productId) => {
    const currentProduct = catalogById.get(String(productId));
    const currentQty = Number(currentProduct?.qty) || 0;
    const nextQty = Math.max(0, currentQty - qtyToDeduct);

    batch.update(doc(db, "products", productId), {
      qty: nextQty,
    });

    updatedProducts.push({
      ...currentProduct,
      id: productId,
      qty: nextQty,
    });
  });

  await batch.commit();

  return {
    applied: true,
    updatedCount: qtyToDeductByProductId.size,
    updatedProducts,
  };
};
